var _excluded = ["verticalHeaders", "columnKey", "children", "isNumeric"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { chakra, forwardRef, useStyles } from '@chakra-ui/system';
import { __DEV__ } from '@chakra-ui/utils';
import React from 'react';
import { RTableConsumer } from './ResponsiveTable';
/* -------------------------------------------------------------------------------------------------
 * RTd: Tablecell
 * -----------------------------------------------------------------------------------------------*/

/** 
 * @description tablecell td handles mobile changes in each cell 
 * */

var TdInner = forwardRef((props, ref) => {
  var {
    verticalHeaders,
    columnKey = 0,
    children,
    isNumeric
  } = props,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var styles = useStyles();

  var tdPivotedStyles = _extends({}, styles.td, styles.tdPivoted);

  return /*#__PURE__*/React.createElement(chakra.td, _extends({
    __css: tdPivotedStyles,
    className: "tdPivoted",
    "data-is-numeric": isNumeric,
    ref: ref,
    role: "gridcell"
  }, rest), /*#__PURE__*/React.createElement(chakra.div, {
    __css: styles.tdBefore,
    className: "tdInnerBefore"
  }, verticalHeaders == null ? void 0 : verticalHeaders[columnKey]), children != null ? children : /*#__PURE__*/React.createElement("div", null, "\xA0"));
});
export var RTd = forwardRef((props, ref) => /*#__PURE__*/React.createElement(RTableConsumer, null, headers => /*#__PURE__*/React.createElement(TdInner, _extends({}, props, {
  ref: ref,
  verticalHeaders: headers
}))));

if (__DEV__) {
  RTd.displayName = 'RTd';
}
//# sourceMappingURL=RTd.js.map